import { SuccessResponse } from '@/types'
import { ExportWashingHistoryByDayRequest } from '@/types/apis/washingHistory/ExportWashingHistoryByDayRequest'
import { ExportWashingHistoryByDayResponse } from '@/types/apis/washingHistory/ExportWashingHistoryByDayResponse'
import { ExportWashingHistoryByRangeDayRequest } from '@/types/apis/washingHistory/ExportWashingHistoryByRangeDayRequest'
import { GetWashingHistoryByDayRequest } from '@/types/apis/washingHistory/GetWashingHistoryByDayRequest'
import { GetWashingHistoryByDayResponse } from '@/types/apis/washingHistory/GetWashingHistoryByDayResponse'
import { GetWashingHistoryByRangeDayRequest } from '@/types/apis/washingHistory/GetWashingHistoryByRangeDayRequest'
import { GetWashingHistoryByRangeDayResponse } from '@/types/apis/washingHistory/GetWashingHistoryByRangeDayResponse'
import { LaundryRequest } from '@/types/apis/washingHistory/LaundryRequest'

import axios from './axios'

const API_ENDPOINT = '/laundry'

export const getWashingHistoryByDay = (
  request: GetWashingHistoryByDayRequest
): Promise<GetWashingHistoryByDayResponse> => {
  return axios.get(`${API_ENDPOINT}/laundry-by-date`, { params: request })
}

export const exportWashingHistoryByDay = (
  request: ExportWashingHistoryByDayRequest
): Promise<ExportWashingHistoryByDayResponse> => {
  return axios.get(`${API_ENDPOINT}/export-laundry-by-date`, { params: request })
}

export const getWashingHistoryByRangeDayApi = (
  request: GetWashingHistoryByRangeDayRequest
): Promise<GetWashingHistoryByRangeDayResponse> => {
  return axios.get(`${API_ENDPOINT}/laundry-by-range-date`, { params: request })
}

export const exportWashingHistoryByRangeDayApi = (
  request: ExportWashingHistoryByRangeDayRequest
): Promise<ExportWashingHistoryByDayResponse> => {
  return axios.get(`${API_ENDPOINT}/export-laundry-by-range-date`, { params: request })
}

export const createLaundryApi = (request: LaundryRequest): Promise<SuccessResponse> => {
  return axios.post(API_ENDPOINT, request)
}

export const deleteLaundryApi = (id: number): Promise<SuccessResponse> => {
  return axios.delete(`${API_ENDPOINT}/${id}`)
}
